import { render, staticRenderFns } from "./sampleData.vue?vue&type=template&id=cb854880&scoped=true&"
import script from "./sampleData.vue?vue&type=script&lang=js&"
export * from "./sampleData.vue?vue&type=script&lang=js&"
import style0 from "./sampleData.vue?vue&type=style&index=0&id=cb854880&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb854880",
  null
  
)

export default component.exports